<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'
import { merchantComputed } from '@state/helpers'

const conditionList = (list) => {
  return list.filter(({condition})=>{
    if (condition) return condition()
    return true
  })
}
const initData = () => {
  return {
    title:'會員等級',
    image:[],
    description:'',
    isEnabled: 0,
  }
}

export default {
  props: {

  },
  data() {
    return {
      activeTab: '1',
      defaultValue: cloneDeep(initData),
      tabList: Object.freeze(conditionList([
        {
          title: '基本設定',
          component: () => lazyLoadComponent(import('./components/MemberLevelBasicSetting')),
        },
        {
          title: '等級設定',
          component: () => lazyLoadComponent(import('./components/MemberLevelSetting')),
        },
      ])),
    }
  },
  computed: {
    ...merchantComputed,
    // defaultValue(){
    //   return this.currentMerchant.merchantConfig.memberlevelSetting ? cloneDeep(this.currentMerchant.merchantConfig.memberlevelSetting) : {}
    // }
  },
  created() {
    this.getMemberLvelSetting()
  },
  methods: {
    async getMemberLvelSetting() {
      const { response } = await this.$store.dispatch(
        'merchant/getCosmeticBasicSet',
        {
          "type": "level",
        }
      )
      this.defaultValue = cloneDeep(response.items)
    }
  },
}
</script>

<template>
  <div :class="$style.page">
    <el-tabs v-model="activeTab" stretch class="isStyleBaseLine isSecond">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.title"
        :name="`${index}`"
      ></el-tab-pane>
    </el-tabs>
      <component 
        :is="tabList[activeTab].component"
        :default-value="defaultValue"
      >
    </component>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
